const getters = {
  currentUser: state => state.currentUser,
  dialogOpen: state => state.dialogOpen,
  isBusy: state => state.isBusy,
  providers: state => state.providers,
  reports: state => state.reports,
  reportDetails: state => state.reportDetails,
  buildVersion: state => state.buildVersion,
  volunteerVerification: state => state.volunteerVerification,
  verifications: state => state.verifications,
  postbackErrorLogs: state => state.postbackErrorLogs,
  postbackErrorLog: state => state.postbackErrorLog,
  selectedUser: state => state.selectedUser,
  users: state => state.users
};

export default getters;
